import SafeDrivingResetKr from '@di-shared/features/safe-driving/kr/SafeDrivingReset.kr';

export interface SafeDrivingResetPageProps {
  vin: string;
}

function SafeDrivingResetPage({vin}: SafeDrivingResetPageProps) {
  return <SafeDrivingResetKr vin={vin} />;
}

export default SafeDrivingResetPage;
